"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Select = void 0;

var tslib_1 = require("tslib");

var React = tslib_1.__importStar(require("react"));

var select_1 = tslib_1.__importDefault(require("antd/es/select"));

exports.Select = function (_a) {
  var _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$dropdownClassName = _a.dropdownClassName,
      dropdownClassName = _a$dropdownClassName === void 0 ? '' : _a$dropdownClassName,
      _a$bordered = _a.bordered,
      bordered = _a$bordered === void 0 ? 'full' : _a$bordered,
      _a$width = _a.width,
      width = _a$width === void 0 ? 'auto' : _a$width,
      props = tslib_1.__rest(_a, ["className", "dropdownClassName", "bordered", "width"]);

  var borderedClass = bordered === 'bottom' ? 'clp-select_bordered_bottom' : '';
  var widthClass = width === 'auto' ? '' : "clp-select_width_".concat(width);
  return React.createElement(select_1["default"], Object.assign({
    dropdownClassName: "clp-select__dropdown ".concat(dropdownClassName),
    className: "clp-select ".concat(borderedClass, " ").concat(widthClass, " ").concat(className)
  }, props));
};